import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import BuyerSideNav from '../component/buyer/BuyerSideNav';
import BuyerTopNav from '../component/buyer/BuyerTopNav';
import ChatBot from '../component/ChatBot';
import '../css/sellerLayout.css';
import { IconPackage, IconShoppingCart } from '@tabler/icons-react';
import RoleToggle from '../component/RoleToggle';
import Navbar from './Navbar';

const BuyerLayout = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isSideNavOpen, setIsSideNavOpen] = useState(!isMobile);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            setIsSideNavOpen(!mobile);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isMobile) setIsSideNavOpen(false);
    }, [location.pathname, isMobile]);

    const toggleSideNav = () => setIsSideNavOpen((prev) => !prev);

    const isChatPage = location.pathname.includes('/messages');

    return (
        <div className="layout">
            {isMobile ? <Navbar /> : <BuyerTopNav onToggle={toggleSideNav} />}
            <div className={`main-content ${isSideNavOpen ? 'sidenav-open' : ''}`} >
                <div className="sidenav-overlay" onClick={() => setIsSideNavOpen(false)}></div>
                <div className="sidenav-container">
                    <RoleToggle />
                    <BuyerSideNav isOpen={isSideNavOpen} onClose={() => setIsSideNavOpen(false)} />
                </div>
                <div className={`page-content ${isChatPage ? 'no-padding' : ''}`}>
                    <Outlet />
                </div>
            </div>
            <ChatBot />
        </div>
    );
};

export default BuyerLayout;
